const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/pages/DashboardPage/Cards/NextSurgeryAppointment/NextSurgeryAppointmentCard.tsx';
import * as React from 'react';
import { useUpcomingSurgeryAppointment } from 'App/store/appointment';
import textMap from './translations';
import { DashboardCard } from '../DashboardCard';
import { AppointmentDetails } from '../../Components/appointmentCards/AppointmentDetails';

export const NextSurgeryAppointmentCard = (_props: {}): any => {
    const { data: appointment, isPendingOrLoading: isDataLoading } = useUpcomingSurgeryAppointment();
    const hasData = !!appointment;

    const renderAppointmentDetails = () => {
        if (!appointment) return null;

        return (
            <AppointmentDetails
                title={textMap.cardTitle}
                appointment={appointment}
                hideAppointmentTitle={true}
                hideAppointmentName={true}
                hideStatus={true}
            />
        );
    };

    return (
        <DashboardCard iconClass="icons8-calendar" isDataLoading={isDataLoading} hasData={hasData}>
            {renderAppointmentDetails()}
        </DashboardCard>
    );
};
